import {
  Card,
  Dialog,
  DialogContent,
  Grow,
  IconButton,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import {
  dateFormats,
  formatDateTime,
  printRoundedNumber,
} from '../../shared/utils';
import {
  CompactTableCell,
  CompactTableRow,
  TableTitle,
} from '../shared/ui-extension';

export const CostDetailDialog = ({ costDetails, setCostDetails }) => {
  const { fifoLayers, locationName } = costDetails;
  return (
    <Dialog
      open={fifoLayers?.length > 0}
      onClose={() =>
        // This view is read-only, so closing on a backdrop click can't discard
        // any user changes.
        setCostDetails({})
      }
      TransitionComponent={Grow}
      maxWidth='l'
    >
      <IconButton
        aria-label='close'
        onClick={() => setCostDetails({})}
        sx={{
          position: 'absolute',
          right: 8,
          top: 8,
          zIndex: 1,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent>
        <TableContainer component={Card}>
          <TableTitle title={`Fifo Layers - ${locationName}`} />
          <Table>
            <TableHead>
              <TableRow>
                <CompactTableCell>Date Received</CompactTableCell>
                <CompactTableCell>Reference #</CompactTableCell>
                <CompactTableCell>Quantity Received</CompactTableCell>
                <CompactTableCell>Quantity Left</CompactTableCell>
                <CompactTableCell>Unit Cost</CompactTableCell>
                <CompactTableCell>Allocated Cost</CompactTableCell>
                <CompactTableCell>Additional Cost</CompactTableCell>
                <CompactTableCell>Total Cost</CompactTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {fifoLayers?.map((fl) => {
                const {
                  fifo_layer_number,
                  date_received,
                  unit_cost,
                  allocated_cost,
                  other_cost,
                  landed_cost,
                  fifo_layer_qty,
                  qty_received,
                  journal,
                  document_no,
                } = fl;
                return (
                  <CompactTableRow key={fifo_layer_number}>
                    <CompactTableCell>
                      {formatDateTime(date_received, dateFormats.short)}
                    </CompactTableCell>
                    <CompactTableCell>
                      {journal}: {document_no}
                    </CompactTableCell>
                    <CompactTableCell>
                      {printRoundedNumber(qty_received, 0)}
                    </CompactTableCell>
                    <CompactTableCell>
                      <Typography
                        sx={
                          (!fifo_layer_qty && {
                            fontWeight: 'bold',
                            color: 'red',
                          }) ||
                          (+fifo_layer_qty < +qty_received && {
                            fontWeight: 'bold',
                            color: 'LimeGreen',
                          }) ||
                          null
                        }
                      >
                        {printRoundedNumber(fifo_layer_qty, 0)}
                      </Typography>
                    </CompactTableCell>
                    <CompactTableCell>
                      $ {printRoundedNumber(unit_cost, 5)}
                    </CompactTableCell>
                    <CompactTableCell>
                      $ {printRoundedNumber(allocated_cost, 5)}
                    </CompactTableCell>
                    <CompactTableCell>
                      $ {printRoundedNumber(other_cost, 5)}
                    </CompactTableCell>
                    <CompactTableCell>
                      $ {printRoundedNumber(landed_cost, 5)}
                    </CompactTableCell>
                  </CompactTableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>
    </Dialog>
  );
};
